import dayjs from 'dayjs';

import type {DateTimeObj} from './types';

import {ISOStringToDatetimeObj} from './ISOStringToDatetimeObj';

export const timestampToDateTimeObj = (timeStamp: number): DateTimeObj => {
  return ISOStringToDatetimeObj(dayjs(timeStamp).toISOString());
};
